export abstract class Selectable {
  constructor(public id: string) {

  }
  public abstract getCaption(): string;
  public abstract getData(): any;
}



// WEBPACK FOOTER //
// ./src/app/select/selectable.ts